import React, { useEffect } from "react";
import { PiLink } from "react-icons/pi";
import { toast } from "../../utils/appToast";
import api from "../chat/api";
import useGooglePicker from "../RFP_Manager/useGooglePicker";
import useSalesforcePicker from "../RFP_Manager/useSalesforcePicker";
import sfdcImg from "./sfdc.png";
import { PageHeader, PrimaryButton, SecondaryButton, ListCard, StatusPill } from "./settings/ui";

const IntegrationRow = ({ logo, name, description, connected, onConnect, onDisconnect }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-4 p-5 bg-white [&+&]:border-t [&+&]:border-black/[0.07]">
    <span className="w-12 h-12 shrink-0 rounded-[10px] border border-black/10 bg-white flex items-center justify-center">
      <img src={logo} alt="" className="w-7 h-7 object-contain" />
    </span>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2">
        <span className="text-[15px] font-semibold text-[#18101C]">{name}</span>
        {connected && <StatusPill tone="green">Connected</StatusPill>}
      </div>
      <div className="mt-0.5 text-[13px] text-[#71717A]">{description}</div>
    </div>
    {connected ? (
      <SecondaryButton
        onClick={onDisconnect}
        className="hover:!text-[#E21919] hover:!border-[rgba(226,25,25,0.4)]"
      >
        Disconnect
      </SecondaryButton>
    ) : (
      <PrimaryButton icon={PiLink} onClick={onConnect}>
        Connect
      </PrimaryButton>
    )}
  </div>
);

const Integration = () => {
  const { isDriveConnected, handleConnectDrive, verifyDriveConnection } =
    useGooglePicker();
  const {
    isSFDCConnected,
    handleConnectSFDC,
    handleDisconnectSFDC,
    verifySFDCConnection,
  } = useSalesforcePicker();

  useEffect(() => {
    verifyDriveConnection();
    verifySFDCConnection();
  }, []);

  const handleDisconnectDrive = async () => {
    try {
      await api.post("/api/v1/accounts/google-drive/disconnect/");
      toast.success("Google Drive disconnected!");
      await verifyDriveConnection();
    } catch (err) {
      console.error("Error disconnecting Google Drive:", err);
      toast.error("Failed to disconnect Google Drive.");
    }
  };

  return (
    <div className="w-full font-outfit">
      <PageHeader
        scope="You"
        title="Integrations"
        description="Connect your tools to bring documents into the Knowledge Base."
      />

      <ListCard className="max-w-[860px]">
        <IntegrationRow
          logo="/google-drive-icon.svg"
          name="Google Drive"
          description="Upload Google Docs, Sheets, Slides and other files."
          connected={isDriveConnected}
          onConnect={handleConnectDrive}
          onDisconnect={handleDisconnectDrive}
        />
        <IntegrationRow
          logo={sfdcImg}
          name="Salesforce"
          description="Pull relevant records and documents into the Knowledge Base."
          connected={isSFDCConnected}
          onConnect={handleConnectSFDC}
          onDisconnect={handleDisconnectSFDC}
        />
      </ListCard>
    </div>
  );
};

export default Integration;
